module.exports = __webpack_public_path__ + "img/24000.281bb252.jpg";